import React, {
    useEffect,
    useState,
    useContext,
    useCallback
} from 'react';
import _ from 'lodash';
import { setComponentMapOverrides } from '@jutro/uiconfig';
import {
    Main,
    Icon,
    CurrencyField,
    ModalNextProvider
} from '@jutro/components';
import { Table, TableColumn } from '@jutro/datatable';
import './App.scss';
import 'gw-capability-quoteandbind-react';
import { ViewModelServiceFactory } from 'gw-portals-viewmodel-js';
import { DependencyProvider } from 'gw-portals-dependency-react';
import { policyJobComponentMap, policyJobComponents } from 'gw-capability-policyjob-react';
import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { AccurateBreakpointPropagation } from 'gw-jutro-adapters-react';
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import { routeConfirmationModal } from '@jutro/router';
import vmTranslator, { messages as commonMessages } from 'gw-platform-translations';
import { platformComponents, platformComponentMap, ImageComponent } from 'gw-components-platform-react';
import { brandingData, setBranding } from 'gw-portals-branding-js';
import {
    MenuBarComponent,
    PageHeaderComponent,
    producerEngageComponentMap,
    producerEngageAdditionalComponents
} from 'gw-capability-gateway-react';
import { SelectProducerContextProvider } from 'gw-gateway-common-react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from 'react-router-dom';

import { ErrorBoundary } from 'gw-portals-error-react';
import { RoutingTracking } from 'gw-portals-tracking-react';
import { DynamicRoute, withAuthContextProvider } from 'gw-digital-auth-react';
import { GatewayAvailabilityService } from 'gw-capability-gateway-policycommon';
import { GatewayRenewalService } from 'gw-capability-gateway-policyrenewal';
import { GatewayEndorsementService } from 'gw-capability-gateway-policychange';
import { LoadSaveService, CustomQuoteService } from 'gw-capability-gateway-quoteandbind';
import { UserService, SubmissionService, JobService } from 'gw-capability-gateway';
import { BopCoverablesService } from 'gw-capability-gateway-policyjob-bop';
import { GatewayClaimService } from 'gw-capability-gateway-claim';
import { GatewayBillingService } from 'gw-capability-gateway-billing';
import { GatewayFNOLService } from 'gw-capability-gateway-fnol';
import { AccountService } from 'gw-capability-gateway-policy';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { GatewaySpreadsheetService } from 'gw-capability-gateway-spreadsheet';
import { ProducerInfoService } from 'gw-capability-profileinfo';
import { WizardPageTemplateWithTitle } from 'gw-portals-wizard-react';
import { PropertyCodeLookupService } from 'gw-capability-quoteandbind-cp';
import { AddressLookupComponentMap, AddressLookupComponents } from 'gw-capability-address-react';
import { LoginCapabilityComponentMap, LoginCapabilityComponents } from 'gw-portals-login-react';
import { VehicleInfoLookupComponentMap, VehicleInfoLookupComponents } from 'gw-capability-vehicleinfo-react';
import { GatewayClaimDocumentService } from 'gw-capability-gateway-claimdocument';

import EntryPage from '../pages/EntryPage/EntryPage';
import PageRouting from '../routes/PageRouting';
import messages from './App.messages';
// make sure the IFRAME is imported as is
// eslint-disable-next-line import/no-webpack-loader-syntax,import/no-unresolved
import '!!raw-loader!../../public/redirect-login.html';
import {ServiceManager} from "@jutro/services";
import ResetPasswordComponent
    from "../customer/modules-react/nexus-portals-login-react/ResetPasswordComponent/ResetPasswordComponent";

setComponentMapOverrides({
    ...platformComponentMap,
    ...AddressLookupComponentMap,
    ...VehicleInfoLookupComponentMap,
    ...producerEngageComponentMap,
    ...policyJobComponentMap,
    ...LoginCapabilityComponentMap,
    Icon: { component: 'Icon' },
    Table: { component: 'Table' },
    TableColumn: { component: 'TableColumn' },
    CurrencyField: { component: 'CurrencyField' },
    WizardPageTemplateWithTitle: { component: 'WizardPageTemplateWithTitle' },
    // replace the native IMG component with a proxied version
    img: { component: 'img' }
},
{
    ...platformComponents,
    ...AddressLookupComponents,
    ...VehicleInfoLookupComponents,
    ...producerEngageAdditionalComponents,
    ...policyJobComponents,
    ...LoginCapabilityComponents,
    Icon,
    Table,
    TableColumn,
    CurrencyField,
    WizardPageTemplateWithTitle,
    img: ImageComponent
});


const getUserAuthData = (authData, authHeader) => {
    return UserService.getGateWayCurrentUser(authHeader);
};

function App() {
    const translator = useContext(TranslatorContext);
    const [viewModelService, updateViewModelService] = useState(undefined);
    const breakpoint = useContext(BreakpointTrackerContext)
    const localeService = ServiceManager.getService('locale-service');
    useEffect(
        () => {
            /*localeService.saveLanguage(localeService.localeToIETF(localeService.getPreferredLocale()));*/
            //const v = localeService.getLanguageUpdatedFrom();
            if (localStorage.getItem('isUpdatedFrom') !== 'preferences') {
                localeService.saveLanguage("en-CA");
                localStorage.setItem('isUpdatedFrom', 'app');
                /*localeService.saveLanguage("en-CA");
                localeService.setLanguageUpdatedFrom('app');*/
            }
            const translatorFn = vmTranslator(translator);
            import(
                /* webpackChunkName: "product-metadata" */
                // eslint-disable-next-line import/no-unresolved
                'product-metadata'
            ).then((productMetadata) => {
                const { default: result } = productMetadata;
                updateViewModelService(
                    ViewModelServiceFactory.getViewModelService(result, translatorFn)
                );
            });
        },
        [translator]
    );
    if (brandingData.BRANDING) {
        setBranding();
    }

    const handleError = useCallback((error = {}) => {
        const state = {
            pathname: '/',
            state: error
        };
        /*Temp code to resolve landing page error on launching of PE login url*/
        if(error.error !== 'checkIfLoggedInError'){
            return ModalNextProvider.showAlert({
                title: messages.error,
                message: messages.errorMessage,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).then(
                () => <Redirect to={state} />,
                _.noop
            );
        } else {
            return <Redirect to={state} />;
        }
    }, []);

    return (
        <AccurateBreakpointPropagation>
            <DependencyProvider
                value={{
                    BopCoverablesService: BopCoverablesService,
                    LoadSaveService: LoadSaveService,
                    CustomQuoteService: CustomQuoteService,
                    ClaimService: GatewayClaimService,
                    ClaimDownloadService: GatewayClaimDocumentService,
                    FNOLService: GatewayFNOLService,
                    AvailabilityService: GatewayAvailabilityService,
                    RenewalService: GatewayRenewalService,
                    DocumentService: GatewayDocumentService,
                    SpreadsheetService: GatewaySpreadsheetService,
                    EndorsementService: GatewayEndorsementService,
                    AccountService: AccountService,
                    BillingService: GatewayBillingService,
                    UserService: UserService,
                    PropertyCodeLookupService: PropertyCodeLookupService,
                    ContactService: ProducerInfoService,
                    quoteUnderWritingService: {
                        referToUnderwriter: SubmissionService.referToUnderwriter,
                        withdrawJobByJobNumber: JobService.withdrawJobByJobNumber,
                        approveUnderwritingIssue: LoadSaveService.approveUnderwritingIssue
                    }
                }}
            >
                <ViewModelServiceContext.Provider value={viewModelService}>
                    <Router
                        basename="/producer-engage"
                        getUserConfirmation={routeConfirmationModal}
                    >
                        <RoutingTracking />
                        <ModalNextProvider />
                        <ErrorBoundary onError={handleError}>
                            <Switch>
                                <Route exact path="/login-page" component={EntryPage} />
                                <Route exact path="/auth/resetpassword" component={ResetPasswordComponent} />
                                <DynamicRoute path="/">
                                    <SelectProducerContextProvider>
                                        <PageHeaderComponent />
                                        { breakpoint != 'phone' && <MenuBarComponent /> }                                        
                                        <Main className="producerEngageContainer">
                                            <PageRouting />
                                        </Main>
                                    </SelectProducerContextProvider>
                                </DynamicRoute>
                            </Switch>
                        </ErrorBoundary>
                    </Router>
                </ViewModelServiceContext.Provider>
            </DependencyProvider>
        </AccurateBreakpointPropagation>
    );
}

export default withAuthContextProvider({ onAuthDataCreation: getUserAuthData })(App);
